import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Store {

  // SIGNALS
  
  private _remote_player_names = signal<string[]>([]);
  private _local_player_name = signal<string>('');

  private _start_name = signal<string>('');
  private _word = signal<string>('');

  // GETTERS

  public remote_player_names = this._remote_player_names.asReadonly();
  public local_player_name = this._local_player_name.asReadonly();

  public start_name = this._start_name.asReadonly();
  public word = this._word.asReadonly();

  // SETTERS

  setPlayerNames(player_names: string[], local_player_name: string){

    const remote_player_names = player_names.filter(
      player_name => player_name !== local_player_name
    );

    this._remote_player_names.set(remote_player_names);
    this._local_player_name.set(local_player_name);

  }

  deleteRemotePlayer(remote_player_name: string){

    this._remote_player_names.update(remote_player_names => 
      remote_player_names.filter(
        player_name => player_name !== remote_player_name
      )
    );

  }

  setStartName(start_name: string){
    this._start_name.set(start_name);
  }

  setWord(word: string){
    this._word.set(word);
  }

}
